import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { RouterProvider } from 'react-router';
import { AuthProvider, type AuthAdapter } from '@/auth';
import { ConfirmProvider } from '@/components/feedback/ConfirmProvider';
import { NotificationsProvider } from '@/components/feedback/NotificationsProvider';
import { router } from '@/router';
import { theme } from '@/theme';

export function App({ adapter }: { adapter: AuthAdapter }) {
  return (
    <ThemeProvider theme={theme} defaultMode="system">
      <CssBaseline enableColorScheme />
      <AuthProvider adapter={adapter}>
        <NotificationsProvider>
          <ConfirmProvider>
            <RouterProvider router={router} />
          </ConfirmProvider>
        </NotificationsProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
